import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src2425249190/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
